export const DEFAULT_PAGE_SIZE = 6
export const DEFAULT_PAGE = 1

export const MODAL_NAMES = {
  CREATE_OR_UPDATE: 'CREATE_OR_UPDATE_ADDRESS',
  DELETE: 'DELETE_ADDRESS',
}
